module.exports = __webpack_public_path__ + "static/assets/7aab3ecbbeae29719b6d94aa21ff41dd.svg";